import React from "react";
import { createDAppKit, DAppKitProvider } from "@mysten/dapp-kit-react";
import { SuiJsonRpcClient, getJsonRpcFullnodeUrl } from "@mysten/sui/jsonRpc";

// Sui mainnet only (Li.Fi routes are mainnet).
export const suiDAppKit = createDAppKit({
  networks: ["mainnet"],
  defaultNetwork: "mainnet",
  createClient(network) {
    return new SuiJsonRpcClient({ url: getJsonRpcFullnodeUrl(network) });
  },
  autoConnect: true,
  storage: typeof window !== "undefined" ? window.localStorage : undefined,
  storageKey: "dex-sui-wallet",
});

export function SuiProvider({ children }) {
  return <DAppKitProvider dAppKit={suiDAppKit}>{children}</DAppKitProvider>;
}
